import { render, staticRenderFns } from "./BuildingSocietyMessagesEscalated.vue?vue&type=template&id=b59ee9a0&scoped=true&"
import script from "./BuildingSocietyMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59ee9a0",
  null
  
)

export default component.exports